'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _utils = require('./utils');

var _constants = require('./utils/constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * A React Component to be used in Applications, adding styles to styled
 * components from a hierarchical distance.
 *
 * When a styled component finds it's name in a parent StylesProvider, it will
 * add it's styles object to it's overall styles resolution.
 */
var StylesProvider = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(StylesProvider, _Component);
  (0, _createClass3.default)(StylesProvider, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return (0, _defineProperty3.default)({}, _constants.CONTEXT_EMITTER, this.emitter);
    }
  }, {
    key: 'parentComponentSelectors',
    get: function get() {
      return this.parentEmitter && this.parentEmitter.data ? this.parentEmitter.data : undefined;
    }
  }]);

  function StylesProvider(props, context) {
    var _ref2;

    (0, _classCallCheck3.default)(this, StylesProvider);

    for (var _len = arguments.length, rest = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      rest[_key - 2] = arguments[_key];
    }

    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref2 = StylesProvider.__proto__ || (0, _getPrototypeOf2.default)(StylesProvider)).call.apply(_ref2, [this, props, context].concat(rest)));

    _this.getComponentSelectors = _this.getComponentSelectors.bind(_this);
    _this.updateComponentSelectors = _this.updateComponentSelectors.bind(_this);
    _this.onParentEmit = _this.onParentEmit.bind(_this);
    _this.parentEmitter = context[_constants.CONTEXT_EMITTER];
    _this.emitter = (0, _utils.createEmitter)();
    _this.emitter.data = _this.getComponentSelectors(props);
    return _this;
  }

  (0, _createClass3.default)(StylesProvider, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (this.parentEmitter) {
        this.parentEmitter.on(this.onParentEmit);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.parentEmitter) {
        this.parentEmitter.off(this.onParentEmit);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.components !== this.props.components) {
        this.updateComponentSelectors(nextProps);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react.Children.only(this.props.children);
    }
  }, {
    key: 'onParentEmit',
    value: function onParentEmit() {
      this.updateComponentSelectors(this.props);
    }
  }, {
    key: 'getComponentSelectors',
    value: function getComponentSelectors(props) {
      return props.mergeComponentConfigs(this.parentComponentSelectors, props.components);
    }
  }, {
    key: 'updateComponentSelectors',
    value: function updateComponentSelectors(props) {
      var _this2 = this;

      (0, _utils.raf)(function () {
        _this2.emitter.data = _this2.getComponentSelectors(props);
        _this2.emitter.emit();
      });
    }
  }]);
  return StylesProvider;
}(_react.Component), _class.defaultProps = {
  mergeComponentConfigs: _utils.defaultComponentConfigsMerge
}, _class.contextTypes = (0, _defineProperty3.default)({}, _constants.CONTEXT_EMITTER, _propTypes2.default.object), _class.childContextTypes = (0, _defineProperty3.default)({}, _constants.CONTEXT_EMITTER, _propTypes2.default.object), _temp);
exports.default = StylesProvider;
process.env.NODE_ENV !== "production" ? StylesProvider.propTypes = {
  components: _propTypes2.default.objectOf(_propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.array])),
  mergeComponentConfigs: _propTypes2.default.func,
  children: _propTypes2.default.element.isRequired
} : void 0;